const NotOrderedProductsIconSubcategory = () => {
  return (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_2141_25610)" />
      <g clip-path="url(#clip0_2141_25610)">
        <path
          d="M38.2804 46.8052C38.2804 41.2117 42.863 36.6965 48.4565 36.6965V25.0378C48.4565 24.0943 47.7152 23.353 46.7717 23.353H38.3478V33.4617L34.9783 31.2378L31.6087 33.4617V23.353H23.1848C22.2413 23.353 21.5 24.0943 21.5 25.0378V45.2552C21.5 46.1987 22.2413 46.94 23.1848 46.94H38.2804C38.2804 46.8726 38.2804 46.8726 38.2804 46.8052Z"
          fill="white"
        />
        <path
          d="M48.3891 39.5942C44.3456 39.5942 40.9761 42.8964 40.9761 46.9399C40.9761 51.0508 44.2782 54.3529 48.3217 54.3529C52.4326 54.3529 55.7348 51.0508 55.7348 47.0073C55.7348 42.8964 52.4326 39.5942 48.3891 39.5942ZM47.2435 43.0986C47.2435 42.4921 47.7152 42.0203 48.3217 42.0203C48.9282 42.0203 49.4 42.4921 49.4 43.0986V47.6812C49.4 48.2877 48.9282 48.7595 48.3217 48.7595C47.7152 48.7595 47.2435 48.2877 47.2435 47.6812V43.0986ZM48.3891 51.9268C47.7826 51.9268 47.3109 51.4551 47.3109 50.8486C47.3109 50.2421 47.7826 49.7703 48.3891 49.7703C48.9956 49.7703 49.4674 50.2421 49.4674 50.8486C49.4674 51.4551 48.9956 51.9268 48.3891 51.9268Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2141_25610"
          x1="5"
          y1="4.84619"
          x2="65.5"
          y2="66.3462"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0090AA" />
          <stop offset="1" stop-color="#00768B" />
        </linearGradient>
        <clipPath id="clip0_2141_25610">
          <rect width="34.2348" height="31" fill="white" transform="translate(21.5 23.353)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default NotOrderedProductsIconSubcategory
